import * as actionTypes from "../actionTypes.js";

const initialState = {
  companiesList: null,
  companyInfo: null,

  myProfile: null,

  companyConfig: {
    domestic_enabled: false,
    international_enabled: false,
    industry: "GENERIC"
  },
  classesEnabled: false,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_COMPANIES_DASHBOARD:
      return { ...state, companiesList: action.payload };
    case actionTypes.GET_COMPANY_DASHBOARD:
      return { ...state, companyInfo: action.payload };

    case actionTypes.GET_MY_PROFILE_DASHBOARD:
      return { ...state, myProfile: action.payload };

    case actionTypes.GET_COMPANY_CONFIG_DASHBOARD:
      return { ...state, companyConfig: action.payload };      
    
    case actionTypes.GET_COMPANY_CLASSES_ENABLED_DASHBOARD:
      return { ...state, classesEnabled: action.payload };
      

    case actionTypes.SELECT_COMPANY:
      return { 
        ...state, 
        companyInfo: null, 
        companyConfig: {
          "domestic_enabled": true,
          "international_enabled": false,
          "industry": "GENERIC"
        },
        classesEnabled: false 
      };
    case actionTypes.LOG_OUT:
      return initialState;
    
    default:
      return state;
  }
};

export default dashboardReducer;